// DJB-142 / DJB-147: the time-scope presets shared by the Transactions and
// Top 25 Tracks widgets. Each preset maps to a `from` timestamp computed
// client-side; `to` is omitted so the backend defaults it to now.

export const TIME_SCOPES = [
  { key: '1d', label: '1d' },
  { key: '3d', label: '3d' },
  { key: '7d', label: '7d' },
  { key: '30d', label: '30d' },
  { key: 'ytd', label: 'YTD' },
  { key: '1y', label: '1yr' },
  { key: 'lifetime', label: 'Lifetime' },
];

const DAYS_BY_SCOPE = { '1d': 1, '3d': 3, '7d': 7, '30d': 30 };

export const getScopeFromDate = (scopeKey, now = new Date()) => {
  const days = DAYS_BY_SCOPE[scopeKey];
  if (days !== undefined) {
    return new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
  }
  if (scopeKey === 'ytd') {
    return new Date(now.getFullYear(), 0, 1);
  }
  if (scopeKey === '1y') {
    const from = new Date(now.getTime());
    from.setFullYear(from.getFullYear() - 1);
    return from;
  }
  // lifetime: everything since the epoch
  return new Date(0);
};

// "from=<ISO-8601>" ready to append to a statistics endpoint query string
export const buildScopeQuery = (scopeKey, now = new Date()) =>
  `from=${encodeURIComponent(getScopeFromDate(scopeKey, now).toISOString())}`;
